<template>
  <div class="page">
    <div class="mt2 mb4 fs5 fw4 fc--primary">
      {{ clinicInfo.fullname }}
    </div>

    <div class="row--central mb3">
      <div class="label label--secondary fs1 mh2">
        {{ spiderman.moment(shift.date).format('MM/DD') }}
        ({{ spiderman.moment(shift.date).locale('zh_cn').format('dd') }})
      </div>
      <div class="label label--secondary fs1 mh2">
        {{ shift.division }}
      </div>
    </div>
    <Shift
      :shift="shift"
      :has-button="false"
    />
    <div class="page__form mv7">
      <input
        type="text"
        placeholder="真實姓名"
        v-model="memberInfo.name"
        class="mb4"
      >
      <input
        type="text"
        placeholder="身份證號碼"
        v-model="memberInfo.id"
        class="mb4"
      >
      <input
        type="text"
        placeholder="西元生日 共八碼"
        v-model="memberInfo.birthdate"
        class="mb4"
      >
      <input
        type="text"
        placeholder="手機號碼"
        v-model="memberInfo.mobile"
        class="mb4"
      >
    </div>
    <div
      @click="$emit('makeAppointment')"
      class="label label--primary mb4"
    >
      確認預約
    </div>
    <div
      @click="$emit('clearMemberInfo')"
      class="label label--secondary mb4"
    >
      清除預約資訊
    </div>
    <div
      @click="$emit('cancel')"
      class="label label--secondary"
    >
      取消返回
    </div>
  </div>
</template>

<script>
import { computed } from 'vue';
import composable from '@/composable/index';
import spiderman from '@/spiderman/index';
import Shift from '../components/Shift.vue';

export default {
  components: { Shift },
  props: {
    clinicInfo: {
      type: Object,
      default() {
        return {};
      },
    },
    shift: {
      type: Object,
      default() {
        return {};
      },
    },
    modelMemberInfo: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  emits: [
    'cancel',
    'update:modelMemberInfo',
    'clearMemberInfo',
    'makeAppointment',
  ],
  setup(props, { emit }) {
    const memberInfo = computed({
      get: () => props.modelMemberInfo,
      set: (value) => emit('update:modelMemberInfo', value),
    });

    return {
      composable,
      spiderman,
      memberInfo,
    };
  },
};
</script>
